export const METRICS_PLUGIN_OPTIONS = Symbol.for('METRICS_PLUGIN_OPTIONS');
export const METRICS_SERVICE = Symbol.for('METRICS_SERVICE');
export const METRICS_REGISTRY = Symbol.for('METRICS_REGISTRY');
